import React from 'react';
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

import { PageFooter } from './footer';


class About extends React.Component {

    componentDidMount() {
        AOS.init({
            duration: 400,
            anchor: '#app',
            placement: 'top-center',
            easing: 'ease-in-out',
            delay: 800,
        });
    }

    render () {
        return (
            <div className="MainContainer">
                <div className="HalfContainer">
                    <h1
                        data-aos="fade-up"
                        data-aos-delay="200"
                        className="Type-h1"
                    >
                        Believing in you from the beginning.
                    </h1>
                    <div data-aos="fade">
                        <p className="Type-body u-mb-4">
                            We seek to partner with extraordinary founders who challenge convention and aim to build indispensable, enduring companies. We are particularly attracted by the contrarian and the non-obvious.
                        </p>
                        <h2 className="Type-h2">
                            What sets us apart from traditional VC?
                        </h2>
                        <p className="Type-body">
                            We combine the personal relationship of a traditional VC fund based in Silicon Valley—FCVC—with the global reach of the world’s first online VC platform—FundersClub.
                        </p>
                        <p className="Type-body">
                            Via our VC fund, FCVC, we leverage our personal experience as entrepreneurs, our experience working with hundreds of founders as VCs, and the scaled insights we’ve learned from our VC platform. As founders, we built, grew, and sold our own startups. As VCs, we’ve been among the very first investors to support what are now multiple billion-dollar category-leading startups. We’re at the ready to help our founders with our Seed and follow-on capital, warm intros to the world’s leading Series A and later VC’s, and advice and connections for scaling their businesses.
                        </p>
                        <p className="Type-body">
                            Via the VC platform we built, FundersClub, we enable our founders to plug into a community of 275 top startups (comprising of 630+ founders & co-founders) and to access a network of 20,000+ accredited investors (41% of whom are VPs, Presidents, and Directors, 29% of whom are C-level execs, 10% of whom are founders/owners). This is a scale and a reach that few traditional VCs can replicate. Founders have used the FundersClub network for sharing best practices, warm intros to customers, recruiting top candidates, and more.
                        </p>
                        <p className="Type-body u-mb-4">
                            <Link className="Type-link" to="/faq">
                                Visit our FAQ to learn more.
                            </Link>
                        </p>
                        <h2 className="Type-h2 u-mb-3">
                            What our founders have to say
                        </h2>
                        <div className="Type-quote">
                            <p className="Type-body">
                                “Coinbase might not be here without FC— they did half our seed round during a time when fundraising was tough. This was before Union Square, Andreessen, and DFJ. Working with FC was a big win for us in the early days and they had a lot of foresight vs the rest of the market.”
                            </p>
                            <p className="Type-body u-mb-0">
                                <strong>Brian Armstrong, Co-founder & CEO, Coinbase</strong>
                            </p>
                        </div>
                        <div className="Type-quote">
                            <p className="Type-body">
                                "The FC team has been an incredible resource. They connected us with top-tier sales prospects including a world-class hedge fund which has become one of our best customers."
                            </p>
                            <p className="Type-body u-mb-0">
                                <strong>Mike Babineu, Co-founder and CEO, SecondMeasure</strong>
                            </p>
                        </div>
                        <div className="Type-quote">
                            <p className="Type-body">
                                "FC has been one of our most helpful investors. They'll go to bat for you like no other and I tell anyone who can get their money to take it."
                            </p>
                            <p className="Type-body u-mb-0">
                                <strong>Gautam Sivakumar, Founder and CEO, Medisas</strong>
                            </p>
                        </div>
                        <div className="Type-quote">
                            <p className="Type-body">
                                “FC is not just an investor, they've been a great partner for us. We've been able to tap into the FC network to meet other startup teams who are facing similar problems, and connect with many potential hires. FundersClub is a startup itself, meaning that Alex and Boris are able to better understand what founders are going through, making them truly founder-friendly"
                            </p>
                            <p className="Type-body u-mb-0">
                                <strong>Laura Behrens Wu, Founder and CEO, Shippo</strong>
                            </p>
                        </div>
                    </div>
                </div>
                <PageFooter/>
            </div>
        );
    };
};

export default About;



// WEBPACK FOOTER //
// ./src/components/about.js